import { render, staticRenderFns } from "./forward.vue?vue&type=template&id=4d98aab8&"
import script from "./forward.vue?vue&type=script&lang=js&"
export * from "./forward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports